import React from 'react'

import './dash.scss'

export const Dash: React.FC = () => <hr className="dash" />
